import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "TopHeader" }
const _hoisted_2 = ["href"]
const _hoisted_3 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UTCTimeIndicator = _resolveComponent("UTCTimeIndicator")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", {
      href: _ctx.homePageUrl,
      title: "StudyPortals MyDashboard",
      class: "Logo"
    }, [...(_cache[0] || (_cache[0] = [
      _createElementVNode("img", {
        class: "LogoImage",
        src: "https://monet-prtl-co.imgix.net/Shared/studyportals_logo_white.svg",
        alt: "Studyportals - University Administration"
      }, null, -1 /* CACHED */)
    ]))], 8 /* PROPS */, _hoisted_2),
    _createElementVNode("div", null, [
      _createVNode(_component_UTCTimeIndicator),
      _createElementVNode("a", {
        class: "NavigatorButton SignOutButton",
        href: _ctx.logOutUrl
      }, " Sign Out ", 8 /* PROPS */, _hoisted_3)
    ])
  ]))
}